import { render, staticRenderFns } from "./NationalityFlag.vue?vue&type=template&id=466045e7&scoped=true"
import script from "./NationalityFlag.vue?vue&type=script&lang=js"
export * from "./NationalityFlag.vue?vue&type=script&lang=js"
import style0 from "./NationalityFlag.vue?vue&type=style&index=0&id=466045e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466045e7",
  null
  
)

export default component.exports